export { default as AboutPage } from './about-page.jsx';
export { default as ArtistDetailPage } from './artist-detail-page.jsx';
export { default as ArtistListingPage } from './artist-listing-page.jsx';
export { default as GenericPage } from './generic-page.jsx';
export { default as Home } from './home-page.jsx';
export { default as WorkDetailPage } from './work-detail-page.jsx';
export { default as WorkListingPage } from './work-listing-page.jsx';
